// extracted by mini-css-extract-plugin
export default {"header":"Header_header__i+wuo","windowName":"Header_windowName__Z+XQE","date":"Header_date__6JHt8"};